import React from "react";
import CommonNavbar from "../components/CommonNavbar/CommonNavbar";
import CommonFooter from "../components/CommonFooter/CommonFooter";
import Franchise from "../components/BecomeAFranchise/Franchise";
import FranchiseIntroduction from "../components/BecomeAFranchise/FranchiseIntroduction";
import FranchiseBenefits from "../components/BecomeAFranchise/FranchiseBenefits";
import FranchiseBookingForm from "../components/BecomeAFranchise/FranchiseBookingForm";

const FranchisePage = () => {
  return (
    <div>
      <div>
        <CommonNavbar hide_btn="d-none" show_btn="d-block" />
        <Franchise />
        <FranchiseIntroduction />
        <FranchiseBenefits />
        <FranchiseBookingForm />
        <CommonFooter />
      </div>
    </div>
  );
};

export default FranchisePage;
